import {Component, OnInit} from "@angular/core";
import {ActivatedRoute}    from "@angular/router";
import {SchemaSettings}    from "./components/schema.models";
import {Schema}            from '../shared/api/bases/proxy/schemas/schema.interface';
import {ContactMoment}     from '../shared/api/bases/proxy/schemas/contactMoments/api.models';
import {Base}              from '../shared/api/bases/api.models';

@Component({
    selector : 'copy-schema',
    template: require('./copy.component.html')
})

export class CopySchemaComponent implements OnInit {
    base: Base;
    schema: Schema;
    moments: ContactMoment[];
    settings: SchemaSettings;

    constructor(private route: ActivatedRoute) {}

    ngOnInit() {
        this.base     = this.route.snapshot.data['base'] as Base;
        this.schema   = this.route.snapshot.data['schema'] as Schema;
        this.moments  = this.route.snapshot.data['contactMoments'].result as ContactMoment[];

        this.settings = new SchemaSettings();
        this.settings.treatAsNew = true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/copy.component.ts